












































































































import {Vue, Component, Prop} from 'vue-property-decorator'
import {OrbitClaimStep} from '@/enums/OrbitClaimStep'
import {NeoHelper} from '@/helpers/NeoHelper'
import {$} from '@/facade'
import {getN3InvocationBuilder} from '@/model/wallets/invocationsBuilder'
import {OrbitClaimBarItem} from '@/components/orbit/OrbitClaimBar.vue'
import {OrbitRoundReward} from '@/model/resource/OrbitRoundReward'
import {OrbitRoundRewardCollection} from '@/model/collection/OrbitRoundRewardCollection'
import OrbitClaimFormStep from '@/components/orbit/OrbitClaimFormStep.vue'
import OrbitLoadingTransactionStep from '@/components/orbit/OrbitLoadingTransactionStep.vue'
import OrbitSuccessStep from '@/components/orbit/OrbitSuccessStep.vue'
import OrbitInsufficientGasStep from '@/components/orbit/OrbitInsufficientGasStep.vue'
import OrbitUnexpectedErrorStep from '@/components/orbit/OrbitUnexpectedErrorStep.vue'
import OrbitRejectedByTheUserStep from '@/components/orbit/OrbitRejectedByTheUserStep.vue'

export type OrbitIndividualReward = {
  instanceId: number
  projectScriptHash: string
  amount: number
}

@Component({
  computed: {
    OrbitClaimStep() {
      return OrbitClaimStep
    },
  },
  components: {
    OrbitClaimFormStep,
    OrbitLoadingTransactionStep,
    OrbitSuccessStep,
    OrbitInsufficientGasStep,
    OrbitUnexpectedErrorStep,
    OrbitRejectedByTheUserStep,
  },
})
export default class OrbitClaimModal extends Vue {
  @Prop({type: Array, required: true}) items!: OrbitClaimBarItem[]
  @Prop({type: Array, required: true})
  individualRewards!: OrbitIndividualReward[]
  @Prop({type: Array, required: true}) rewards!: OrbitRoundReward[]

  currentStep: OrbitClaimStep = OrbitClaimStep.REVIEW_FORM
  transactionHash: string | null = null

  async handleClaim() {
    const address = $.walletAdapter.n3Address
    if (!address) return

    try {
      for (const individualReward of this.individualRewards) {
        this.currentStep = OrbitClaimStep.WAITING_SIGNATURE

        const n3InvocationBuilder = getN3InvocationBuilder()
        const orbitClaimInvocation = n3InvocationBuilder.claimOrbitInvocation({
          projectScriptHash: individualReward.projectScriptHash,
          instanceId: individualReward.instanceId.toString(),
        })

        this.transactionHash = await $.walletAdapter.invokeN3Wallet(
          orbitClaimInvocation
        )

        if (!this.transactionHash) throw new Error('Undefined transaction')

        this.currentStep = OrbitClaimStep.VALIDATING_TRANSACTION

        const isTransactionValid = await NeoHelper.validateTransaction(
          this.transactionHash
        )
        if (!isTransactionValid) throw new Error('Failed to verify transaction')

        await this.registerClaim(
          address,
          this.transactionHash,
          individualReward.projectScriptHash
        )
      }

      this.currentStep = OrbitClaimStep.CLAIMED

      $.toast.success('system.success.persist')
    } catch (error) {
      this.threatError(error)
    }
  }

  private async registerClaim(
    address: string,
    transactionHash: string,
    projectScriptHash: string
  ) {
    const claimedRewards = this.rewards.filter(
      reward =>
        reward.orbitProject?.contract?.hash === projectScriptHash &&
        reward.status === 'approved'
    )

    if (claimedRewards.length === 0) return

    await new OrbitRoundRewardCollection().claimOrbitRoundReward({
      address,
      transactionHash,
      idOrbitRoundRewardPks: claimedRewards.map(
        reward => reward.idOrbitRoundRewardPk
      ),
    })

    claimedRewards.forEach(reward => {
      reward.status = 'claimed'
      reward.transactionHash = transactionHash
    })
  }

  onClickCloseModal() {
    if (
      this.currentStep === OrbitClaimStep.WAITING_SIGNATURE ||
      this.currentStep === OrbitClaimStep.VALIDATING_TRANSACTION
    ) {
      return
    }

    this.closeModal()
  }

  closeModal() {
    this.currentStep = OrbitClaimStep.REVIEW_FORM
    this.transactionHash = null
    this.$emit('close')
  }

  private threatError(error: any) {
    console.error(error)

    const isNeonWalletRejected =
      error.message && String(error.message).includes('rejected by the user')

    const isNeoLineWalletRejected =
      error.description &&
      error.description === 'The user cancels, or refuses the dapps request'

    if (isNeonWalletRejected || isNeoLineWalletRejected) {
      this.currentStep = OrbitClaimStep.REJECTED_BY_THE_USER
      return
    }

    const hasInsufficientFunds =
      error.message && String(error.message).includes('insufficient funds')
    if (hasInsufficientFunds) {
      this.currentStep = OrbitClaimStep.INSUFFICIENT_GAS
      return
    }

    this.currentStep = OrbitClaimStep.UNKNOWN_ERROR
  }
}
